/**
 * Constants
 * */
export const moduleName = `siteKey`;

/**
 * Reducer
 * */

export default function reducer(state = ``, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const siteKeySelector = (state) => state[moduleName];
